<template>
    <div class="check-holder" :class="{disabled: disabled}">
        <label class="checkbox control-label" @click.stop="update">
            <div class="outer" v-bind:class="{checked: checked}"></div>
            <slot></slot>
        </label>
    </div>
</template>
<script>
    export default {
        model: {
            prop: 'modelValue',
            event: 'change'
        },
        props: {
            disabled: {default: false},
            value: {}, 
            simple: {default: false, type: Boolean},
            on: {default: false, type: Boolean},
            modelValue: {default: false}, 
            trueValue: {default: true}, 
            falseValue: {default: false},
            valueKey: {default: 'id', type: String}
        },
        computed: {
            checked() {
                if(this.simple){
                    return this.on;
                }
                if (this.modelValue instanceof Array) {
                    for(var i = 0; i < this.modelValue.length; i++){
                        if(this.modelValue[i][this.valueKey] == this.value[this.valueKey]){
                            return true;
                        }
                    }
                    return false;
                }
                return this.modelValue === this.trueValue;
            }
        },
        methods: {
            update(){
                this.$emit('toggle');
                if(this.simple){
                    return;
                }
                if(this.disabled){
                    return;
                }
                if (this.modelValue instanceof Array) {
                    let newValue = [];
                    let has = false;
                    for(var i = 0; i < this.modelValue.length; i++){
                        if(this.modelValue[i][this.valueKey] == this.value[this.valueKey]){
                            has = true;
                        }
                    }
                    for(var c = 0; c < this.modelValue.length; c++){
                        if(this.modelValue[c][this.valueKey] != this.value[this.valueKey]){
                            newValue.push(JSON.parse(JSON.stringify(this.modelValue[c])));
                        }
                    }
                    if(!has){
                        newValue.push(JSON.parse(JSON.stringify(this.value)));
                    }
                    this.$emit('change', newValue)
                } else {
                    this.$emit('change', !this.checked ? this.trueValue : this.falseValue);
                }
            }
        },
        mounted() {
            
        }
    }
</script>